import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { StarIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function GoogleReviewsHighlight() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-2084">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-2085">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-2086">
          {/* Google G Logo Placeholder */}
          <div className="w-12 h-12 rounded-full bg-white shadow-md flex items-center justify-center mb-6" data-id="element-2087">
            <span className="text-2xl font-bold font-[Poppins,_sans-serif]" style={{
            color: '#4285F4'
          }} data-id="element-2088">
              G
            </span>
          </div>

          {/* Large Rating Number */}
          <h2 className="text-[56px] lg:text-[80px] text-black font-[700] font-[Poppins,_sans-serif] leading-none mb-4" data-id="element-2089">
            4.5
          </h2>

          {/* Stars */}
          <div className="flex gap-1 justify-center mb-4" data-id="element-2090">
            {[...Array(4)].map((_, i) => <StarIcon key={i} size={28} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2091" />)}
            <StarIcon size={28} className="text-[#FFD700] fill-[#FFD700]/50" data-id="element-2092" />
          </div>

          {/* Text */}
          <p className="text-black text-lg font-[Poppins,_sans-serif] mb-10" data-id="element-2093">
            Based on 250+ Google Reviews
          </p>

          {/* CTA */}
          <a href="https://www.google.com" target="_blank" rel="noopener noreferrer" data-id="element-2094">
            <Button variant="outline" size="lg" className="border-2 border-black text-black hover:bg-black hover:text-white w-full sm:w-auto" data-id="element-2095">
              READ MORE ON GOOGLE
            </Button>
          </a>
        </AnimateOnScroll>
      </div>
    </section>;
}